import { sharedSocket } from '@/websocketV2'
import {getUid} from '../utils/index'
import {getStockProfile} from '../api'
import store from './index'

const wsV2 = sharedSocket
wsV2.init()

function isCurrentStock (obj) {
  return getUid(obj) === getUid({
    market: store.state.market,
    code: store.state.code
  })
}

function bindListeners() {
  if (!wsV2.websocket) return
  const ws = wsV2.websocket
  ws.on('onSTATIC', msg => {
    const data = msg?.QuoteData?.StaticData?.[0]
    if (data) store.commit('setStatic', data)
  })
  ws.on('onSTATUS', msg => {
    const data = msg?.QuoteData?.InstStatusData?.[0]
    if (data != null) store.commit('setStatus', data.StatusType)
  })
  ws.on('onSTATISTICS', msg => {
    let tmpMarket = (msg?.Market || '').replace('DELAY_', '')
    if (!isCurrentStock({market: tmpMarket, code: msg?.Inst})) return
    const data = msg?.QuoteData?.StatisticsData?.[0]
    if (data) store.commit('setStatistics', data)
  })
  ws.on('onDYNA', msg => {
    let tmpMarket = (msg?.Market || '').replace('DELAY_', '')
    if (!isCurrentStock({market: tmpMarket, code: msg?.Inst})) return
    const data = msg?.QuoteData?.DynaData?.[0]
    if (data) store.commit('setDyna', data)
  })
  ws.on('onTICK', msg => {
    let tmpMarket = (msg?.Market || '').replace('DELAY_', '')
    if (!isCurrentStock({market: tmpMarket, code: msg?.Inst})) return
    const data = msg?.QuoteData?.TickData
    if (msg?.yclose !== undefined) store.commit('setTickBase', msg.yclose)
    if (data) store.commit('setTick', data)
  })
}

if (wsV2.websocket) bindListeners()

export default {
  async subscribe (code, market, region) {
    let tmpMarket = 'DELAY_'+ market
    const ws = wsV2.websocket
    if (!ws) return
    // 港股 201，美股 204
    console.log('region',region)
    const dynaMsgId = region === 'USA' ? 204 : 201
    ws.safeSubscribeSTATISTICS(code, tmpMarket, dynaMsgId)
    ws.safeSubscribeDYNA(code, tmpMarket, dynaMsgId)
    ws.safeSubscribeTICK(code, tmpMarket)
    ws.safeSubscribeSTATUS(code, tmpMarket)
    region !== 'CN' && ws.safeSubscribeSTATIC(code, tmpMarket, dynaMsgId)
    const res = await getStockProfile(market + code)
    store.commit('setProfile', res.ShareholderEquity)
  }
}
